/**
 * @file yupバリデーションのカスタムメソッド拡張
 *
 * yup.string()に全角チェック（zenkaku）、全角カナチェック（zenkakukana）、
 * 電話番号チェック（telno）のカスタムバリデーションメソッドを追加する。
 * check.tsの判定関数を内部で利用している。
 * 各フォームのyupスキーマ定義から参照される。
 */
import * as yup from 'yup';
import { isZenkakuKanaOnly, isZenkakuOnly } from './check';

// yup.StringSchemaにカスタムメソッドの型定義を追加
declare module 'yup' {
  interface StringSchema {
    zenkaku(this: StringSchema, param: string): StringSchema;
    zenkakukana(this: StringSchema, param: string): StringSchema;
    telno(this: StringSchema, param: string): StringSchema;
  }
}

// 全角文字のみを許可するバリデーションメソッド
yup.addMethod(yup.string, 'zenkaku', function zenkaku(param: string) {
  return this.test('zenkaku', param, (value: string | undefined) => {
    return isZenkakuOnly(value?.trim());
  });
});

// 全角カタカナのみを許可するバリデーションメソッド
yup.addMethod(yup.string, 'zenkakukana', function zenkakukana(param: string) {
  return this.test('zenkakukana', param, (value: string | undefined) => {
    return isZenkakuKanaOnly(value?.trim());
  });
});

// 電話番号形式を検証するバリデーションメソッド（0始まり10～11桁）
yup.addMethod(yup.string, 'telno', function zenkakukana(param: string) {
  return this.test('telno', param, (value: string | undefined) => {
    if (!value) return false;
    return /[0]{1}[0-9]{9,10}/.test(value);
  });
});

export default yup;
